/**
 * Formater un numéro de téléphone en (XXX) XXX-XXXX
 */
export const formatPhoneNumber = (value) => {
  if (!value) return value;
  
  // Retirer tous les caractères non-numériques
  const phoneNumber = value.replace(/[^\d]/g, '');
  
  // Limiter à 10 chiffres
  const phoneNumberLength = phoneNumber.length;
  
  if (phoneNumberLength < 4) return phoneNumber;
  
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

/**
 * Retirer le formatage pour stocker en DB
 */
export const unformatPhoneNumber = (value) => {
  if (!value) return value;
  return value.replace(/[^\d]/g, '');
};
